import * as React from 'react'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../../ui/ActionButton/ActionButton'

import media from '../../../services/generateMediaQueries'

import InsufficientPointsImage from '../../../assets/img/insufficient-points.png'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('xsmall')`
    border-radius: 0;
    max-width: unset;
  `}
`

const ModalContent = styled.div`
  position: relative;
  padding: 2rem;
  padding-top: 3rem;
  margin: 0 auto;
  width: 325px;
  min-height: 400px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
`

const ModalImage = styled.img.attrs({ src: InsufficientPointsImage })`
  display: block;
  margin: 0 auto;
  margin-bottom: 2.375rem;
  width: 10rem;
`

const Title = styled.h2`
  color: var(--color-primary);
  font-size: 1.375rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
  margin: 0;
  margin-bottom: 0.625rem;
`

const Description = styled.p`
  color: var(--color-primary);
  font-size: 0.875rem;
  line-height: 1.375rem;
  text-align: center;
  margin: 0;
  margin-bottom: 1.5rem;
`

const BlockActionButton = styled(ActionButton)`
  width: 100%;
`

const overlay = {
  zIndex: 10005,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function InsufficientPointsModal(props) {
  const { show, onConfirmClick } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{ overlay, content }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <ModalContent>
        <ModalImage />
        <Title>Insufficient points</Title>
        <Description>
          Sorry, you currently don’t have enough points to make this redemption.
          Keep using your registered card/s at Ayala Malls to earn more points!
        </Description>
        <BlockActionButton variant="primary" small onClick={onConfirmClick}>
          Got It
        </BlockActionButton>
      </ModalContent>
    </StyledReactModal>
  )
}

InsufficientPointsModal.defaultProps = {}

InsufficientPointsModal.propTypes = {
  // TODO: specify prop types
}

export default InsufficientPointsModal
